._card_7v9d8_1 {
  position: relative;
  background: #fff;
  border-radius: 0;
  padding: 24px;
  margin: 0 0 12px;
  box-shadow: 0 0 20px 0 rgba(22, 45, 61, 0.03); }

._card_7v9d8_1 .control-label {
  color: inherit; }

._badge_7v9d8_12 {
  position: absolute;
  right: 24px;
  top: 24px;
  color: #fff;
  background: #fdb10c;
  padding: 3px 6px;
  cursor: default;
  border: 1px solid #fdb10c;
  border-radius: 2px;
  line-height: 0; }

._badge_7v9d8_12 .control-label-base.t21 {
  color: inherit;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 1px; }

._date_7v9d8_30 {
  color: #7a92a5;
  padding-right: 42px;
  padding-bottom: 6px; }

.classic-facelift-skin ._date_7v9d8_30 {
  color: #868aa5; }

._title_7v9d8_38 {
  padding-right: 42px;
  padding-bottom: 12px;
  color: #162d3d; }

.classic-facelift-skin ._title_7v9d8_38 {
  color: #000624; }

._description_7v9d8_46 {
  padding-right: 18px;
  padding-bottom: 18px;
  color: #2b5672; }

.classic-facelift-skin ._description_7v9d8_46 {
  color: #3b4057; }

._buttonGroup_7v9d8_54 {
  display: flex;
  align-items: center; }

._buttonGroup_7v9d8_54 > button + button {
  margin-left: 16px; }
